import React, { createContext } from 'react';

interface ExpandedMenuControllerContextData {
  isExpanded: boolean;
  currentExpanded: string;
  toggleExpandedMenu: (menuId: string, toOpenStatus?: boolean) => void;
}

const ExpandedMenuControllerContext = createContext<ExpandedMenuControllerContextData>(
  {} as ExpandedMenuControllerContextData
);

const ExpandedMenuControllerProvider: React.FC<any> = ({ children }) => {
  const [currentExpanded, setCurrentExpanded] = React.useState<string>('');
  const isExpanded = !!currentExpanded;

  // State can be directly set to true or false instead of toggling
  const toggleExpandedMenu = (menuId: string, toOpenStatus: boolean = null) => {
    if (toOpenStatus === null) {
      setCurrentExpanded((prev) => (prev === menuId ? '' : menuId));
    } else if (toOpenStatus) {
      setCurrentExpanded(menuId);
    } else {
      menuId === currentExpanded && setCurrentExpanded('');
    }
  };

  return (
    <ExpandedMenuControllerContext.Provider
      value={{
        isExpanded,
        currentExpanded,
        toggleExpandedMenu,
      }}
    >
      {children}
    </ExpandedMenuControllerContext.Provider>
  );
};

const useExpandedMenuController = (): ExpandedMenuControllerContextData => {
  const context = React.useContext(ExpandedMenuControllerContext);

  if (!context) {
    throw new Error('useExpandedMenuController must be used within a ExpandedMenuControllerProvider');
  }

  return context;
};

export { useExpandedMenuController, ExpandedMenuControllerProvider };
